import React,{useState, useRef, useEffect, useLayoutEffect, useContext} from 'react'
import { NavLink, useLoaderData, useParams,useLocation, useNavigate } from "react-router-dom"
import { ThemeContext } from '../context/ThemeContext';
import { useDarkMode } from '../customhooks/ThemeHook';
import {SplitText} from "@cyriacbr/react-split-text"
import TitleAnimated from './TitleAnimated'
import { BeakerIcon } from '@heroicons/react/24/solid'
import { Helmet } from 'react-helmet';
import YouTube from "react-youtube";
import SEO from './SEO';
import { generateMovieSchema, generateVideoObjectSchema, generateBreadcrumbSchema } from '../utils/structuredData';
import gsap from 'gsap'
//import { SplitText } from "gsap/SplitText"


var opts = {}

function WorkView(props) {

  function projectDataAfp(slug,data){
    // the code you're looking for
    var slug = slug;
    var obj = data;
    // iterate over each element in the array
    for (var i = 0; i < obj.length; i++){
      // look for the entry with a matching `code` value
      if (obj[i].slug == slug){
         // we found it
         //console.log(obj[i]);
         return (obj[i]);
      }
    }
  }
const location = useLocation();
const navigate = useNavigate();
const theme = useContext(ThemeContext);
const { id } = useParams();


  let projects = (useLoaderData());
  //console.log(projects);
const urlChunk = location.pathname.split('/');

  //const featuredImgRef = useRef();

  const [projDataAfp, setProjDataAfp] = useState();
  const [scrollValue, setScrollValue] = useState(0);
  const [featuredImage, setFeaturedImage] = useState();
  const [posterImage, setPosterImage] = useState();
  const [featuredImageOne, setFeaturedImageOne] = useState();
  const [isPlayer,setIsPlayer] = useState(null);
  const [soundEnabled, setSoundEnabled] = useState(false);

useEffect((props)=> {
document.body.classList.add('path-0','path-1');
},[]);



useLayoutEffect(()=>{
  var _projDataAfp = projectDataAfp(id,projects.items);
  setProjDataAfp(_projDataAfp);
  setFeaturedImage(_projDataAfp.image_thumb_bg.url);
  setPosterImage(_projDataAfp.image_thumb.url);
  setFeaturedImageOne(_projDataAfp.image_thumb_1.url);

  //console.log('yt',_projDataAfp.yt != null ? 'YT ' + _projDataAfp.yt.resourceId.videoId : 'no YT');
  },[location,projDataAfp]);

// Function to gradually increase volume (much slower - 4 seconds)
const gradualVolumeIncrease = (video, targetVolume = 0.3, duration = 4000) => {
  if (!video) {
    console.log('No video provided to gradualVolumeIncrease');
    return;
  }

  console.log('Starting gradual volume increase to', targetVolume);

  const startVolume = 0;
  const volumeStep = targetVolume / (duration / 100); // 100ms intervals
  let currentVolume = startVolume;

  video.muted = false;
  video.volume = 0;

  const volumeInterval = setInterval(() => {
    if (currentVolume < targetVolume) {
      currentVolume += volumeStep;
      video.volume = Math.min(currentVolume, targetVolume);
      console.log('Volume:', video.volume);
    } else {
      video.volume = targetVolume; // Ensure we hit exact target
      console.log('Volume increase complete:', video.volume);
      clearInterval(volumeInterval);
    }
  }, 100); // Update every 100ms for smooth transition

  // Cleanup if video ends or is paused
  const cleanup = () => {
    console.log('Cleaning up volume interval');
    clearInterval(volumeInterval);
  };
  video.addEventListener('pause', cleanup, { once: true });
  video.addEventListener('ended', cleanup, { once: true });
};

// Sound toggle function
const toggleSound = () => {
  const newSoundState = !soundEnabled;
  setSoundEnabled(newSoundState);

  console.log('Toggling sound to:', newSoundState);

  // Apply to currently playing video
  let activeVideo = document.querySelector('video');

  console.log('Found video:', activeVideo);
  console.log('Video paused?', activeVideo ? activeVideo.paused : 'N/A');
  console.log('Video muted?', activeVideo ? activeVideo.muted : 'N/A');

  if (activeVideo) {
    if (newSoundState) {
      // Enabling sound
      console.log('Enabling sound on video');

      // Ensure video is playing before trying to add sound
      if (activeVideo.paused) {
        console.log('Video is paused, trying to restart...');
        activeVideo.play().then(() => {
          gradualVolumeIncrease(activeVideo, 0.3, 4000);
        }).catch(e => {
          console.log('Failed to restart video for sound:', e);
          // Try anyway in case video is loaded
          gradualVolumeIncrease(activeVideo, 0.3, 4000);
        });
      } else {
        // Video already playing, just add sound
        console.log('Video is playing, adding sound...');
        gradualVolumeIncrease(activeVideo, 0.3, 4000);
      }
    } else {
      // Disabling sound - don't pause, just mute
      console.log('Disabling sound on video');
      activeVideo.muted = true;
      activeVideo.volume = 0;
    }
  } else {
    console.log('No video found to toggle sound');
  }
};

// Check if project has video_vimeo
const hasVideo = projDataAfp && projDataAfp.video_vimeo;

  // Generate SEO data for individual project
  const category = urlChunk[1] || 'cine';
  const categoryName = category.charAt(0).toUpperCase() + category.slice(1);

  const breadcrumbs = [
    { name: 'Inicio', url: 'https://afpictures.com' },
    { name: categoryName, url: `https://afpictures.com/${category}` },
    { name: projDataAfp?.name || '...', url: `https://afpictures.com/${category}/${id}` }
  ];

  const movieSchema = generateMovieSchema(projDataAfp);
  const videoSchema = generateVideoObjectSchema(projDataAfp);
  const breadcrumbSchema = generateBreadcrumbSchema(breadcrumbs);

  const combinedSchema = [movieSchema, videoSchema, breadcrumbSchema].filter(Boolean);

  return (
    <>
      {projDataAfp && (
        <SEO
          title={`${projDataAfp.name} | ${categoryName} - AF Pictures`}
          description={projDataAfp.description ? projDataAfp.description.replace(/<[^>]*>/g, '').substring(0, 160) : `Descubre ${projDataAfp.name}, película de ${category} distribuida por AF Pictures. Distribución cinematográfica profesional.`}
          keywords={`${projDataAfp.name}, ${category}, distribución cinematográfica, ${categoryName.toLowerCase()}, AF Pictures, películas independientes, cine español`}
          url={`https://afpictures.com/${category}/${id}`}
          image={projDataAfp.image_thumb?.url || projDataAfp.image_bg_thumb?.url || 'https://afpictures.com/img/af-pictures-og.jpg'}
          structuredData={combinedSchema}
          type="video.movie"
        />
      )}

      {/* Sound Toggle Button - only show if video exists */}
      {hasVideo && (
        <button style={{marginTop:'5px',marginRight:'6px'}}
          onClick={toggleSound}
          className="fixed top-16 md:top-4 right-4 z-50 bg-black bg-opacity-50 hover:bg-opacity-70 text-white p-3 rounded-full transition-all duration-300"
          aria-label={soundEnabled ? "Mute audio" : "Enable audio"}
        >
          {soundEnabled ? (
            // Volume On Icon
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
            </svg>
          ) : (
            // Volume Off Icon
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
            </svg>
          )}
        </button>
      )}

      <div className="relative center items-center">

  <div id="-project-page" className={"-parallax bg-dark " + props.transition}>

  {/* Video Section - if video_vimeo exists */}
  {hasVideo ? (
    <div className="w-full h-[75vh] md:h-[100vh] relative overflow-hidden">
      <video
        className="w-full h-[75vh] md:h-[120vh] object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        controls={false}
        webkit-playsinline="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        onLoadStart={(e) => {
          e.target.play().catch(error => console.log('Autoplay prevented:', error));
        }}
        onCanPlay={(e) => {
          e.target.play().catch(err => console.log('Play failed:', err));
        }}
      >
        <source src={projDataAfp.video_vimeo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Add the gradient overlay */}
      <div className="absolute bottom-0 left-0 w-full h-[28%] bg-gradient-to-t from-zinc-900 to-transparent pointer-events-none"></div>

      {/* Project title/logo overlay */}
      <div style={{display:'flex', height:'100vh'}} className="">
        { projDataAfp &&  projDataAfp.image_logo != null ?
        <div className="absolute bottom-12 md:bottom-18 left-6 md:left-24 text-white"><img className="w-[200px] md:w-[480px]" src={projDataAfp.image_logo} alt="item.logo"/></div>
        :
        <div style={{alignSelf:'center',margin:'0 auto'}} className="sm:overflow-hidden w-[98%] md:w-[80%] p-0 mt-1 pb-4">
        <TitleAnimated
        level={1}
        id_t={'project_title'}
        classes={'notranslate proj-title text-left  inter-bold pt-6  lg:pt-31 xl:pt-80 pb-4 pl-8 text-6xl leading-6*2'}
        letterSpeed={0.02}
        scale={1.0}
        color="white"
        title={projDataAfp ? projDataAfp.name :'...'}
        afterTitle={true}
        />
        </div>
       }
      </div>
    </div>
  ) : (
    /* Original Image Section - if no video_vimeo */
    <div style={{backgroundColor: '#000', backgroundImage: 'url(' + featuredImage + ')',backgroundPosition:'center', backgroundSize:'cover', width: '100vw', marginLeft: 'calc(-50vw + 50%)'}} className="relative background-cover h-[70vh] md:h-[100vh]">
      <div style={{display:'flex', height:'100vh'}} className="">
        { projDataAfp &&  projDataAfp.image_logo != null ?
        <div className="absolute bottom-12 md:bottom-18 left-6 md:left-24 text-white"><img className="w-[200px] md:w-[480px]" src={projDataAfp.image_logo} alt="item.logo"/></div>
        :
        <div style={{alignSelf:'center',margin:'0 auto'}} className="sm:overflow-hidden w-[98%] md:w-[80%] p-0 mt-1 pb-4">
        <TitleAnimated
        level={1}
        id_t={'project_title'}
        classes={'notranslate proj-title text-left  inter-bold pt-6  lg:pt-31 xl:pt-80 pb-4 pl-8 text-6xl leading-6*2'}
        letterSpeed={0.02}
        scale={1.0}
        color="white"
        title={projDataAfp ? projDataAfp.name :'...'}
        afterTitle={true}
        />
        </div>
       }
      </div>
    </div>
  )}

<section className="px-8 md:px-24">
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-12">
  <div className="order-2 sm:order-1 text-white text-left">
    <div className="pt-6  text-left" dangerouslySetInnerHTML={{__html: projDataAfp ? projDataAfp.description :'...' }}/>
  </div>
  <div className="order-1 sm:order-2 text-center">
    <img style={{maxWidth:'360px',margin:'0 auto'}} className="p-0  md:p-6 w-full" src={posterImage} alt=""/>
  </div>
</div>
</section>

{projDataAfp ?
<section id="videoSection" className={"w-full bg-black px-0 relative px-0 md:px-24 md:py-8 md:py-2 mt-12 " + props.transition}>
  { projDataAfp.video ?
    <YouTube
      videoId={projDataAfp.video}
      onReady={(e)=>{
        const player = e.target;
        player.seekTo(0);
        setIsPlayer(player);
      }}
      opts={{
        width: '100%',
        height: '100%',
        playerVars: {
          autoplay: 1,
          mute: 1,
          controls: 1,
          enablejsapi: 1,
          fs: 1,
          loop: 1,
          rel: 0,
          modestbranding: 1,
          showinfo: 0,
          // For loop to work, playlist must be set
          // Use yt_list if available, otherwise use the current video ID
          playlist: projDataAfp.video
        }
      }}
      className={'ytPlayer'}
      style={{maxWidth: 1400+'px', height: 'auto', margin: '0 auto'}}
    />
    :
    ''
  }
</section>
: ''}

{projDataAfp ?
<section id="embeed" className={"w-full bg-black px-0 relative px-0 md:px-24 md:py-8 md:py-2 mt-12 " + props.transition}>
{ projDataAfp ?  <div className="text-white" dangerouslySetInnerHTML={{__html: projDataAfp.html  }}/> : ''}
</section>
: ''}

<section className={ "px-8 md:px-24 pt-12 " + props.transition}>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-12">
        <div  className="text-left text-white">

        {projDataAfp && projDataAfp.desc_art ?   <h3 className="text-6xl capitalize pb-6"> Ficha art&iacute;stica </h3> : ''}
      { projDataAfp ?  <div className="text-white" dangerouslySetInnerHTML={{__html: projDataAfp ? projDataAfp.desc_art :'' }}/> : ''}

        </div>

        <div  className="text-left text-white">
          {projDataAfp && projDataAfp.desc_tec ?  <h3 className="text-6xl capitalize pb-6">Ficha t&eacute;cnica</h3> : ''}
            <div className="text-white" dangerouslySetInnerHTML={{__html: projDataAfp ? projDataAfp.desc_tec :'' }}/>
        </div>

    </div>
    <div style={{borderTop:'0.5px solid #fff'}} className="text-center font-medium text-white mt-12 pt-12 pb-12">
      {/*projDataAfp ?
      <NavLink to={"/"+ projDataAfp.tax[0].slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }}>{'+ ' + projDataAfp.tax[0].name}
      </NavLink> : ''*/}
  </div>

</section>

</div>
</div>
    </>
  )
}

export default WorkView
